import { Component } from "react"

/* Widgets */
import RoundView from "../Round/RoundView"

/* Registry */
import { ultimateThreeHand } from "../Round/registry"


/* Widget GameInformation — THE ROUND OF A MULTI PLAYER TABLE PLAYED ON THREE SHARED BOXES */
class GameInformation extends Component {

    render = () => {

        /* Fields */
        const { uid, gameID, postfix, socket } = this.props

        return <RoundView api={ultimateThreeHand.api} config={ultimateThreeHand} uid={uid} gameID={gameID} postfix={postfix} socket={socket} />
    }

}

export default GameInformation
